import { axiosClientPortalInstance } from "./";

const clientLogin = async (payload) =>
  axiosClientPortalInstance.post("/sessions", payload);

const clientLogout = async (payload) =>
  axiosClientPortalInstance.delete("/sessions", { data: payload });

const clientForgetPassword = async (payload) =>
  axiosClientPortalInstance.post("/clients/forgot_password", payload);

const clientChangePassword = async (payload) =>
  axiosClientPortalInstance.post("/clients/change_password", payload);

/**
 * GET /client_portal/v1/clients/me — current client profile. Used to refresh
 * `client_portal_unseen_notifications_count` on the badge (PROLINE-3641).
 */
const getClientPortalCurrentUser = async () =>
  axiosClientPortalInstance.get("/clients/me", { handlerEnabled: false });

export {
  clientLogin,
  clientLogout,
  clientForgetPassword,
  clientChangePassword,
  getClientPortalCurrentUser,
};
